var React = require('react');

function Money (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("rect",{"fill":"none","height":"24","width":"24"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M12,2C6.48,2,2,6.48,2,12s4.48,10,10,10s10-4.48,10-10S17.52,2,12,2z M12.88,17.76V19h-1.75v-1.29 c-0.74-0.18-2.39-0.77-3.02-2.96l1.65-0.67c0.06,0.22,0.58,2.09,2.4,2.09c0.93,0,1.98-0.48,1.98-1.61c0-0.96-0.7-1.46-2.28-2.03 c-1.1-0.39-3.35-1.03-3.35-3.31c0-0.1,0.01-2.4,2.62-2.96V5h1.75v1.24c1.84,0.32,2.51,1.79,2.66,2.23l-1.58,0.67 c-0.11-0.35-0.59-1.34-1.9-1.34c-0.7,0-1.81,0.37-1.81,1.39c0,0.95,0.86,1.31,2.64,1.9c2.4,0.83,3.01,2.05,3.01,3.45 C15.9,17.17,13.4,17.67,12.88,17.76z"}))]);
}

Money.defaultProps = {"enableBackground":"new 0 0 24 24","height":"24px","viewBox":"0 0 24 24","width":"24px"};

module.exports = Money;

Money.default = Money;
